import { ModelTemplate } from "@models/base/helper-types";
import { TaskFieldSystemType, TaskLayoutBlock, TaskLayoutBlockType as T, TaskFieldSystemType as ST, TF_NAME, TF_ICON } from "./task-layout-block";

export const TASK_SYSTEM_FIELDS: ModelTemplate<TaskLayoutBlock>[] = [
    {
        type: T.System,
        name: TF_NAME[ST.Author],
        icon: TF_ICON[ST.Author],
        systemFieldId: ST.Author,
        showInCard: true,
        description: 'Постановщик (создатель) задачи.',
    },
    {
        type: T.System,
        name: TF_NAME[ST.PlannedHours],
        icon: TF_ICON[ST.PlannedHours],
        systemFieldId: ST.PlannedHours,
        showInCard: true,
        description: 'Запланированное время которое потребуется на выполнение задачи.'
    },
    {
        type: T.System,
        name: TF_NAME[ST.Watchers],
        icon: TF_ICON[ST.Watchers],
        systemFieldId: ST.Watchers,
        description: 'Список людей которым будут приходить уведомления об изменениях в задаче.'
    },
    {
        type: T.System,
        name: TF_NAME[ST.Assignee],
        icon: TF_ICON[ST.Assignee],
        systemFieldId: ST.Assignee,
        showInCard: true,
        description: 'Человек или группа людей на которых назначена задача.'
    },
    {
        type: T.System,
        systemFieldId: ST.ImagePreviews,
        description: 'Блок где будут отображаться миниатюры прикрепленных к задаче картинок и документов.'
    },
    {
        type: T.System,
        name: TF_NAME[ST.Priority],
        icon: TF_ICON[ST.Priority],
        systemFieldId: ST.Priority,
        showInCard: true,
        description: 'Срочность (важность) задачи. Поле отображается только при создании задачи.'
    },
    {
        type: T.System,
        name: TF_NAME[ST.Approver],
        icon: TF_ICON[ST.Approver],
        systemFieldId: ST.Approver,
        description: 'Список людей, которые должны проверить результат выполнения задачи.'
    },
    {
        type: T.System,
        name: TF_NAME[ST.ParentTask],
        icon: TF_ICON[ST.ParentTask],
        systemFieldId: ST.ParentTask,
        description: 'Отображается только для подзадач.'
    },
    {
        type: T.System,
        name: TF_NAME[ST.Link],
        icon: TF_ICON[ST.Link],
        systemFieldId: ST.Link,
        description: 'Связи с другими задачами (блокировка задач, дубликаты и т.д.).'
    },
    {
        type: T.System,
        name: TF_NAME[ST.DueDate],
        icon: TF_ICON[ST.DueDate],
        systemFieldId: ST.DueDate,
        showInCard: true,
        description: 'Срок начала работы над задачей или срок к которому задачу надо завершить.'
    },
    {
        type: T.System,
        name: TF_NAME[ST.Subj],
        icon: TF_ICON[ST.Subj],
        systemFieldId: ST.Subj,
        required: true,
        showInCard: true,
        description: 'Тема или заголовок задачи.'
    },
    {
        type: T.System,
        name: TF_NAME[ST.Tag],
        icon: TF_ICON[ST.Tag],
        systemFieldId: ST.Tag,
        showInCard: true,
        description: 'Список тегов по которым легче находить и фильтровать задачи.'
    },
    {
        type: T.System,
        name: TF_NAME[ST.Text],
        systemFieldId: ST.Text,
        description: 'Подробное описание задачи, текст с широкими возможностями форматирования.'
    },
    {
        type: T.System,
        name: TF_NAME[ST.Checklist],
        icon: TF_ICON[ST.Checklist],
        systemFieldId: ST.Checklist,
        description: 'Список микрозадач, которые можно помечать как выполненные.'
    },
    // {
    //     type: T.System,
    //     name: TF_NAME[ST.Sprint],
    //     icon: TF_ICON[ST.],
    //     systemFieldId: ST.Sprint,
    //     description: 'Переносит задачу из отложенных в активные сразу после создания.'
    // },
];
const TSF: { [id in TaskFieldSystemType]: ModelTemplate<TaskLayoutBlock> } = TASK_SYSTEM_FIELDS.reduce((obj, v) => ({ ...obj, [v.systemFieldId!]: v }), {}) as { [id in TaskFieldSystemType]: ModelTemplate<TaskLayoutBlock> };

export const TASK_DEFAULT_LAYOUT: ModelTemplate<TaskLayoutBlock>[] = [
    TSF[ST.ParentTask],
    TSF[ST.Subj],
    {
        type: T.Container,
        horizontal: true,
        children: [
            TSF[ST.Author],
            TSF[ST.Assignee],
        ]
    },
    TSF[ST.Priority],
    {
        type: T.Container,
        name: 'Дополнительные поля',
        foldable: true,
        folded: true,
        children: [
            TSF[ST.Watchers],
            {
                type: T.Container,
                horizontal: true,
                children: [
                    TSF[ST.DueDate],
                    TSF[ST.PlannedHours],
                ]
            },
            TSF[ST.Tag],
            TSF[ST.Link],
            TSF[ST.Approver],
            TSF[ST.Checklist],
        ]
    },
    TSF[ST.ImagePreviews],
    TSF[ST.Text],
];

export const TASK_DEFAULT_TICKET_LAYOUT: ModelTemplate<TaskLayoutBlock>[] = [
    TSF[ST.Subj],
    // {
    //     type: T.Container,
    //     horizontal: true,
    //     children: [
    //         TSF[ST.Author],
    //         TSF[ST.Assignee],
    //     ]
    // },
    // TSF[ST.Tag],
    TSF[ST.ImagePreviews],
    { ...TSF[ST.Text], name: 'Опишите проблему', icon: undefined },
];

export const TASK_DEFAULT_MINIMAL_LAYOUT: ModelTemplate<TaskLayoutBlock>[] = [
    TSF[ST.Priority],
    TSF[ST.Subj],
    {
        type: T.Container,
        horizontal: true,
        children: [
            TSF[ST.Author],
            TSF[ST.Assignee],
        ]
    },
];
